import { css, SerializedStyles } from '@emotion/react';

export const getNewTicketLinkStyles: SerializedStyles = css({
    justifyContent: 'center',
});
